__turbopack_context__.v({
  "component": "style-module-scss-module__jFrDaq__component",
  "dark": "style-module-scss-module__jFrDaq__dark",
  "hover-wrapper": "style-module-scss-module__jFrDaq__hover-wrapper",
  "large": "style-module-scss-module__jFrDaq__large",
  "light": "style-module-scss-module__jFrDaq__light",
  "medium": "style-module-scss-module__jFrDaq__medium",
  "mobile": "style-module-scss-module__jFrDaq__mobile",
  "small": "style-module-scss-module__jFrDaq__small",
  "xs": "style-module-scss-module__jFrDaq__xs",
});
